module.exports = __webpack_public_path__ + "static/media/karen.cc9e20dc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fotos/karen.png
// module id = 341
// module chunks = 0